module.exports = __webpack_public_path__ + "img/uestcp_logo.8cdafe85.png";